import { clientLogger } from '@/lib/client-logger';

type StopListening = () => void | Promise<void>;

/**
 * Logs a ToDesktop event listener that fails to start and returns the effect cleanup that stops
 * it. ToDesktop subscribes over IPC, so `on` resolves later with the function that stops
 * listening; the cleanup waits for it, and a listener that never started has nothing to stop.
 */
export function listenToDesktopEvent(
  description: string,
  subscription: Promise<StopListening>,
): () => void {
  subscription.catch((error) => {
    clientLogger.error(`Failed to listen for ${description}`, error);
  });

  return () => {
    void subscription.then(
      (stopListening) => stopListening(),
      () => undefined,
    );
  };
}
